export default __webpack_public_path__ + "static/media/object-ungroup.0247612c.svg";